import React, { useEffect, useState } from 'react';
import api from '../utils/axiosInstance';
import axios from 'axios';
import { useImmerReducer } from 'use-immer';
import { Button, Typography, Box, Grid, CircularProgress, 
         CardMedia, CardActions, Card, CardContent, TextField } from '@mui/material'; 
import HomeIcon from '@mui/icons-material/Home';
import Header from './Header';
import { useNavigate } from 'react-router-dom';
import defaultProfilePicture from "./Assets/default3.jpg";

function Agencies() {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const initialState = {
    dataIsLoading: true,
    agenciesList: [],
  };

  function ReducerFunction(draft, action) {
    switch (action.type) {
      case "catchAgencies":
        draft.agenciesList = action.agencyArray;
        break;
      case "loadingDone":
        draft.dataIsLoading = false;
        break;
      default:
        break;
    }
  }

  const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    next: null,
    previous: null,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [noResults, setNoResults] = useState(false); // New state for no results

  useEffect(() => {
    async function GetAgencies() {
      try {
        const response = await api.get(
          // `http://localhost:8000/api/profiles/?page=${currentPage}&agency_name=${searchTerm}`
          `${apiUrl}/api/profiles/?page=${currentPage}&agency_name=${searchTerm}`
        );
        
        dispatch({
          type: "catchAgencies",
          agencyArray: response.data.results,
        });
        setPagination({
          next: response.data.next,
          previous: response.data.previous,
        });
        setNoResults(response.data.results.length === 0); // Check if results are empty
        dispatch({ type: 'loadingDone' });
      } catch (e) {
        console.log("Error fetching agencies:", e.response);
      }
    }
    GetAgencies();
  }, [currentPage, searchTerm]);

  const handleNextPage = () => {
    if (pagination.next) {
      setCurrentPage((prevPage) => prevPage + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handlePreviousPage = () => {
    if (pagination.previous) {
      setCurrentPage((prevPage) => prevPage - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // Reset to the first page when searching
  };

  if (state.dataIsLoading) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <Header />
      <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
        <HomeIcon fontSize="large" />
        <Typography variant="h4" ml={1}>
          Agencies
        </Typography>
      </Box>

      {/* Search Input */}
      <Box display="flex" justifyContent="center" mt={2} mb={2}>
        <TextField
          label="Search by Agency Name"
          variant="outlined"
          value={searchTerm}
          onChange={handleSearch}
          style={{ width: '80%', maxWidth: '600px' }}
        />
      </Box>

      {/* Display "No Results Found" if no results */}
      {noResults && (
        <Box display="flex" justifyContent="center" mt={3}>
          <Typography variant="h6" color="textSecondary">
            No agencies found matching "{searchTerm}"
          </Typography>
        </Box>
      )}

      {/* Display Agencies List */}
      <Grid container justifyContent="center" spacing={2} style={{ padding: "10px" }}>
        {state.agenciesList.map((agency) => {
          function PropertiesDisplay() {
            const sellerId = agency.seller_listings.length > 0 ? agency.seller_listings[0].seller : null;

            if (agency.seller_listings.length === 0) {
              return (
                <Button disabled size="small">No Property</Button>
              );
            } else if (agency.seller_listings.length === 1) {
              return (
                <Button size='small' onClick={() => navigate(`/agency/${sellerId}`)}>1 Property Listed</Button>
              );
            } else {
              return (
                <Button size='small' onClick={() => navigate(`/agency/${sellerId}`)}>{agency.seller_listings.length} Properties Listed</Button>
              );
            }
          }

          if (agency.agency_name && agency.phone_number) {
            return (
              <Grid item xs={12} sm={6} md={4} lg={3} key={agency.id || agency.phone_number} style={{ marginBottom: "1rem" }}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardMedia
                    sx={{ height: 140 }}
                    // image={agency.profile_picture || defaultProfilePicture}
                    // image={`https://res.cloudinary.com/dvisrqloj/${agency.profile_picture}` || defaultProfilePicture}
                    image={agency.profile_picture ? `https://res.cloudinary.com/dvisrqloj/${agency.profile_picture}` : defaultProfilePicture}
                    alt="Profile Picture"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h6" component="div">
                      {agency.agency_name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {agency.bio ? agency.bio.substring(0, 100) : "No bio available"}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    {PropertiesDisplay()}
                  </CardActions>
                </Card>
              </Grid>
            );
          }
          return null;
        })}
      </Grid>

      {/* Pagination Controls */}
      <Box display="flex" justifyContent="center" padding="1rem">
        <Button variant="contained" disabled={!pagination.previous} onClick={handlePreviousPage}>
          Previous
        </Button>
        <Button variant="contained" disabled={!pagination.next} onClick={handleNextPage} style={{ marginLeft: '10px' }}>
          Next
        </Button>
      </Box>
    </>
  );
}

export default Agencies;

// import React, { useEffect, useState } from 'react';
// import api from '../utils/axiosInstance';
// import { useImmerReducer } from 'use-immer';
// import { Button, Typography, Box, Grid, Avatar, CircularProgress, 
//          CardMedia, CardActions, Card, CardContent, TextField } from '@mui/material'; 
// import HomeIcon from '@mui/icons-material/Home';
// import Header from './Header';
// import { useNavigate } from 'react-router-dom';
// import defaultProfilePicture from "./Assets/default3.jpg";

// function Agencies() {
//   const navigate = useNavigate();

//   const initialState = {
//     dataIsLoading: true,
//     agenciesList: [],
//   };

//   function ReducerFunction(draft, action) {
//     switch (action.type) {
//       case "catchAgencies":
//         draft.agenciesList = action.agencyArray;
//         break;
//       case "loadingDone":
//         draft.dataIsLoading = false;
//         break;
//       default:
//         break;
//     }
//   }

//   const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pagination, setPagination] = useState({
//     next: null,
//     previous: null,
//   });
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     async function GetAgencies() {
//       try {
//         const response = await api.get(`http://localhost:8000/api/profiles/?page=${currentPage}&agency_name=${searchTerm}`);
        
//         dispatch({
//           type: "catchAgencies",
//           agencyArray: response.data.results,
//         });
//         setPagination({
//           next: response.data.next,
//           previous: response.data.previous,
//         });
//         dispatch({ type: 'loadingDone' });
//       } catch (e) {
//         console.log("Error fetching agencies:", e.response);
//       }
//     }
//     GetAgencies();
//   }, [currentPage, searchTerm]);

//   const handleNextPage = () => {
//     if (pagination.next) {
//       setCurrentPage((prevPage) => prevPage + 1);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   };

//   const handlePreviousPage = () => {
//     if (pagination.previous) {
//       setCurrentPage((prevPage) => prevPage - 1);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   };

//   const handleSearch = (event) => {
//     setSearchTerm(event.target.value);
//     setCurrentPage(1); // Reset to the first page when searching
//   };

//   if (state.dataIsLoading) {
//     return (
//       <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//         <CircularProgress />
//       </div>
//     );
//   }

//   return (
//     <>
//       <Header />
//       <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
//         <HomeIcon fontSize="large" />
//         <Typography variant="h4" ml={1}>
//           Agencies
//         </Typography>
//       </Box>

//       {/* Search Input */}
//       <Box display="flex" justifyContent="center" mt={2} mb={2}>
//         <TextField
//           label="Search by Agency Name"
//           variant="outlined"
//           value={searchTerm}
//           onChange={handleSearch}
//           style={{ width: '80%', maxWidth: '600px' }}
//         />
//       </Box>

//       <Grid container justifyContent="center" spacing={2} style={{ padding: "10px" }}>
//         {state.agenciesList.map((agency) => {
//           function PropertiesDisplay() {
//             const sellerId = agency.seller_listings.length > 0 ? agency.seller_listings[0].seller : null;

//             if (agency.seller_listings.length === 0) {
//               return (
//                 <Button disabled size="small">No Property</Button>
//               );
//             } else if (agency.seller_listings.length === 1) {
//               return (
//                 <Button size='small' onClick={() => navigate(`/agency/${sellerId}`)}>1 Property Listed</Button>
//               );
//             } else {
//               return (
//                 <Button size='small' onClick={() => navigate(`/agency/${sellerId}`)}>{agency.seller_listings.length} Properties Listed</Button>
//               );
//             }
//           }

//           if (agency.agency_name && agency.phone_number) {
//             return (
//               <Grid item xs={12} sm={6} md={4} lg={3} key={agency.id || agency.phone_number} style={{ marginBottom: "1rem" }}>
//                 <Card sx={{ maxWidth: 345 }}>
//                   <CardMedia
//                     sx={{ height: 140 }}
//                     image={agency.profile_picture || defaultProfilePicture}
//                     alt="Profile Picture"
//                   />
//                   <CardContent>
//                     <Typography gutterBottom variant="h6" component="div">
//                       {agency.agency_name}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {agency.bio ? agency.bio.substring(0, 100) : "No bio available"}
//                     </Typography>
//                   </CardContent>
//                   <CardActions>
//                     {PropertiesDisplay()}
//                   </CardActions>
//                 </Card>
//               </Grid>
//             );
//           }
//           return null;
//         })}
//       </Grid>

//       {/* Pagination Controls */}
//       <Box display="flex" justifyContent="center" padding="1rem">
//         <Button variant="contained" disabled={!pagination.previous} onClick={handlePreviousPage}>
//           Previous
//         </Button>
//         <Button variant="contained" disabled={!pagination.next} onClick={handleNextPage} style={{ marginLeft: '10px' }}>
//           Next
//         </Button>
//       </Box>
//     </>
//   );
// }

// export default Agencies;

// import React, { useEffect, useState } from 'react';
// import Cookies from "js-cookie";
// import api from '../utils/axiosInstance';
// import { useImmerReducer } from 'use-immer';
// import { Button, Typography, Box, Grid, Avatar, CircularProgress, 
//          CardMedia, CardActions, Card, CardContent } from '@mui/material'; 
// import HomeIcon from '@mui/icons-material/Home';
// import Header from './Header';
// import { useNavigate } from 'react-router-dom';
// import defaultProfilePicture from "./Assets/default3.jpg";

// function Agencies() {
//   const navigate = useNavigate();

//   const initialState = {
//     dataIsLoading: true,
//     agenciesList: [],
//   };

//   function ReducerFunction(draft, action) {
//     switch (action.type) {
//       case "catchAgencies":
//         draft.agenciesList = action.agencyArray;
//         break;
//       case "loadingDone":
//         draft.dataIsLoading = false;
//         break;
//       default:
//         break;
//     }
//   }

//   const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pagination, setPagination] = useState({
//     next: null,
//     previous: null,
//   });

//   useEffect(() => {
//     async function GetAgencies() {
//       try {
//         const response = await api.get(`http://localhost:8000/api/profiles/?page=${currentPage}`);
//         console.log("API Response:", response.data);
        
//         dispatch({
//           type: "catchAgencies",
//           agencyArray: response.data.results,
//         });
//         setPagination({
//           next: response.data.next,
//           previous: response.data.previous,
//         });
//         dispatch({ type: 'loadingDone' });
//       } catch (e) {
//         console.log("Error fetching agencies:", e.response);
//       }
//     }
//     GetAgencies();
//   }, [currentPage]);

//   const handleNextPage = () => {
//     if (pagination.next) {
//       setCurrentPage((prevPage) => prevPage + 1);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   };

//   const handlePreviousPage = () => {
//     if (pagination.previous) {
//       setCurrentPage((prevPage) => prevPage - 1);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   };

//   if (state.dataIsLoading === true) {
//     return (
//       <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//         <CircularProgress />
//       </div>
//     );
//   }

//   return (
//     <>
//       <Header />
//       <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
//         <HomeIcon fontSize="large" />
//         <Typography variant="h4" ml={1}>
//           Agencies
//         </Typography>
//       </Box>
//       <Grid container justifyContent="center" spacing={2} style={{ padding: "10px" }}>
//         {state.agenciesList.map((agency) => {
//           function PropertiesDisplay() {
//             const sellerId = agency.seller_listings.length > 0 ? agency.seller_listings[0].seller : null;

//             if (agency.seller_listings.length === 0) {
//               return (
//                 <Button disabled size="small">No Property</Button>
//               );
//             } else if (agency.seller_listings.length === 1) {
//               return (
//                 <Button size='small' onClick={() => navigate(`/agency/${sellerId}`)}>1 Property Listed</Button>
//               );
//             } else {
//               return (
//                 <Button size='small' onClick={() => navigate(`/agency/${sellerId}`)}>{agency.seller_listings.length} Properties Listed</Button>
//               );
//             }
//           }

//           if (agency.agency_name && agency.phone_number) {
//             return (
//               <Grid item xs={12} sm={6} md={4} lg={3} key={agency.id || agency.phone_number} style={{ marginBottom: "1rem" }}>
//                 <Card sx={{ maxWidth: 345 }}>
//                   <CardMedia
//                     sx={{ height: 140 }}
//                     image={agency.profile_picture || defaultProfilePicture}
//                     alt="Profile Picture"
//                   />
//                   <CardContent>
//                     <Typography gutterBottom variant="h6" component="div">
//                       {agency.agency_name}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {agency.bio ? agency.bio.substring(0, 100) : "No bio available"}
//                     </Typography>
//                   </CardContent>
//                   <CardActions>
//                     {PropertiesDisplay()}
//                   </CardActions>
//                 </Card>
//               </Grid>
//             );
//           }
//           return null;
//         })}
//       </Grid>

//       {/* Pagination Controls */}
//       <Box display="flex" justifyContent="center" padding="1rem">
//         <Button variant="contained" disabled={!pagination.previous} onClick={handlePreviousPage}>
//           Previous
//         </Button>
//         <Button variant="contained" disabled={!pagination.next} onClick={handleNextPage} style={{ marginLeft: '10px' }}>
//           Next
//         </Button>
//       </Box>
//     </>
//   );
// }

// export default Agencies;